var _defs, _polygon, _polygon2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsscher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:none;stroke:#000;stroke-linejoin:round;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "26.94 5.75 83.63 5.75 104.2 25.76 104.13 84.19 84.32 104.13 26.38 104.13 5.18 83.15 5.18 26.74 26.94 5.75"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "38.3 27.22 71.98 27.22 83.21 38.38 83.21 71.92 72.05 83.35 38.3 83.35 26.8 71.29 26.8 38.38 38.3 27.22"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 5.18,
    y1: 26.74,
    x2: 26.8,
    y2: 38.38
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 26.94,
    y1: 5.75,
    x2: 38.3,
    y2: 27.22
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 83.63,
    y1: 5.75,
    x2: 71.98,
    y2: 27.22
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 104.2,
    y1: 25.76,
    x2: 83.21,
    y2: 38.38
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 104.13,
    y1: 84.19,
    x2: 83.21,
    y2: 72.2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 84.32,
    y1: 104.13,
    x2: 72.05,
    y2: 83.35
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 26.38,
    y1: 104.13,
    x2: 38.3,
    y2: 83.35
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 5.18,
    y1: 83.15,
    x2: 26.8,
    y2: 71.29
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "30.8 13.05 79.55 13.05 96.2 30.57 96.2 79.62 79.79 96.46 30.78 96.46 12.68 79.04 12.68 30.77 30.8 13.05"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "34.6 20.22 75.78 20.22 89.46 34.62 89.46 75.82 75.62 89.4 34.83 89.4 19.77 75.15 19.77 34.59 34.6 20.22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsscher);
export default __webpack_public_path__ + "static/media/asscher.710d7f6a5e4e17db15ac9ff525ffe866.svg";
export { ForwardRef as ReactComponent };